var __TEMP__ = require('./_baseFindIndex.js');var baseFindIndex = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseIsNaN.js');var baseIsNaN = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_strictIndexOf.js');var strictIndexOf = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseIndexOf;
